// @gqlflow
import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {
    AddFeedbackToDiscussion,
    AddFeedbackToDiscussionVariables,
} from "./__graphql-types__/AddFeedbackToDiscussion.ts";

export const ADD_FEEDBACK_TO_DISCUSSION: GqlOperation<
    AddFeedbackToDiscussion,
    AddFeedbackToDiscussionVariables
> = gqlOp(gql`
    mutation AddFeedbackToDiscussion(
        $focusKind: String
        $focusId: String
        $parentKey: String
        $textContent: String!
        $feedbackType: FeedbackType!
        $fromVideoAuthor: Boolean
        $shownLowQualityNotice: Boolean
    ) {
        addFeedbackToDiscussion(
            focusKind: $focusKind
            focusId: $focusId
            parentKey: $parentKey
            textContent: $textContent
            feedbackType: $feedbackType
            fromVideoAuthor: $fromVideoAuthor
            shownLowQualityNotice: $shownLowQualityNotice
        ) {
            feedback {
                appearsAsDeleted
                author {
                    id
                    kaid
                    nickname
                    avatar {
                        name
                        imageSrc
                    }
                }
                content
                date
                definitelyNotSpam
                deleted
                downVoted
                expandKey
                feedbackType
                flaggedBy
                flags
                focusUrl
                focus {
                    kind
                    id
                    translatedTitle
                    relativeUrl
                }
                fromVideoAuthor
                key
                notifyOnAnswer
                permalink
                qualityKind
                replyCount
                replyExpandKeys
                sumVotesIncremented
                upVoted
            }
            lowQualityResponse {
                feedbackCode
                feedbackChar
                feedbackType
                showLowQualityNotice
            }
            error {
                code
            }
        }
    }
`);
